import { convertTimezone } from '@/shared/lib/helpers/convert-timezone.helper';
import { dateFormat } from '@/shared/lib/helpers/date-format.helper';

import { OrganizationYacht } from '../types/boat.interface';
import { OrganizationYachtResponse } from '../types/boat-api.interface';
import { getYachtStatus } from './get-yacht-status.helper';

export const transformOrganizationYachtResponse = (
	yacht: OrganizationYachtResponse,
	timezone: string,
): OrganizationYacht => ({
	id: String(yacht.id),
	uuid: yacht.boat_uuid,
	hullCode: yacht?.hull_code ?? '',
	name: yacht.name,
	mmsi: yacht?.mmsi ?? '',
	plantAddress: yacht?.plant_address ?? '',
	accountId: yacht.account_node_id,
	accountName: yacht.account_name ?? '',
	shipyardGroupId: yacht.shipyard_node_id,
	customerGroupId: yacht.customer_group_id ?? '',
	shipyardName: yacht.shipyard_name ?? '',
	teamIds: yacht.team_node_ids ?? [],
	teamNames: yacht.team_names ?? [],
	assignmentStatus: yacht.assignment_status,
	accessSources: yacht.access_sources ?? [],
	groupName: yacht?.customer_group_name ?? '',
	users: yacht?.effective_users?.map(({ keycloak_user_id }) => keycloak_user_id) ?? [],
	status: getYachtStatus(yacht.is_in_production, yacht.is_delivered),
	isDataShared: yacht.is_data_shared ?? false,
	createdAt: yacht?.created_at
		? dateFormat(convertTimezone(yacht.created_at, timezone), { format: 'shortMonthDate' })
		: '',
	updatedAt: yacht?.updated_at
		? dateFormat(convertTimezone(yacht.updated_at, timezone), { format: 'shortMonthDate' })
		: '',
	shipyardDeliveryDate: yacht.shipyard_delivery_date ?? '',
	customerDeliveryDate: yacht.customer_delivery_date ?? '',
});
